import React, { useCallback, useContext } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import type { AccountAccessModalResult } from 'components/Account/AccountAccess/AccountAccessModal.types'
import ModalContext from 'contexts/ModalContext'
import purchaseLuxPlus from 'actions/luxPlus/purchaseLuxPlus'
import LuxPlusFreePreviewModal from 'luxPlus/components/modals/LuxPlusFreePreviewModal'
import { selectLoggedIn } from 'selectors/accountSelectors'
import { isSpoofed as isSpoofedSelector } from 'selectors/isSpoofed'
function useLuxPlusLandingActions(freePreviewModalInvitePillCopy?: string) {
  const dispatch = useAppDispatch()
  const showModal = useContext(ModalContext)
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const isSpoofed = useAppSelector(isSpoofedSelector)

  const handleBecomeMember = useCallback(async() => {
    if (isLoggedIn) {
      dispatch(purchaseLuxPlus({ hasJoinFee: true }))
      return
    }
    const result = await showModal<AccountAccessModalResult>(<AccountAccessModal />)
    if (result?.loggedIn) {
      dispatch(purchaseLuxPlus({ hasJoinFee: true }))
    }
  }, [showModal, dispatch, isLoggedIn])

  const handleBecomeMemberNoJoinFee = useCallback(async() => {
    if (isLoggedIn) {
      dispatch(purchaseLuxPlus({ hasJoinFee: false }))
      return
    }
    const result = await showModal<AccountAccessModalResult>(<AccountAccessModal />)
    if (result?.loggedIn) {
      dispatch(purchaseLuxPlus({ hasJoinFee: false }))
    }
  }, [showModal, dispatch, isLoggedIn])

  const handleStartFreePreview = useCallback(() => {
    showModal(<LuxPlusFreePreviewModal invitePillCopy={freePreviewModalInvitePillCopy} />)
  }, [freePreviewModalInvitePillCopy, showModal])

  return {
    handleBecomeMember,
    handleBecomeMemberNoJoinFee,
    handleStartFreePreview,
    isSpoofed,
  }
}

export default useLuxPlusLandingActions
